export const Tier2PassiveCollectibles = [
    ['The Inner Eye', '2'],
    ['Number One', '6'],
    ['Halo of Flies', '10'],
    ['1up!', '11'],
    ['The Virus', '13'],
    ['Roid Rage', '14'],
    ['<3', '15'],
    ['Raw Liver', '16'],
    ['The Compass', '21'],
    ['Lucky Foot', '46'],
    ['Treasure Map', '54'],
    ['Distant Admiration', '57'],
    ['The Battery', '63'],
    ['Steam Sale', '64'],
    ['Mini Mush', '71'],
    ['Rosary', '72'],
    ['Cube of Meat', '73'],
    ['PHD', '75'],
    ['X-Ray Vision', '76'],
    ['Spider Bite', '89'],
    ['Spelunker Hat', '91'],
    ['Super Bandage', '92'],
    ['Little C.H.A.D.', '96'],
    ['Little Gish', '99'],
    ['The Halo', '101'],
    ['Mr. Mega', '106'],
    ['Guardian Angel', '112'],
    ['Demon Baby', '113'],
    ['Ouija Board', '115'],
    ['9 Volt', '116'],
    ['Blood Bag', '119'],
    ['Odd Mushroom', '120'],
    ['Odd Mushroom', '121'],
    ['Whore of Babylon', '122'],
    ['Bobby-Bomb', '125'],
    ['Bomb Bag', '131'],
    ['Guppy\'s Tail', '134'],
    ['Stigmata', '138'],
    ['Scapular', '142'],
    ['Speed Ball', '143'],
    ['Technology 2', '152'],
    ['Chemical Peel', '154'],
    ['The Peeper', '155'],
    ['Habit', '156'],
    ['Sacrificial Dagger', '172'],
    ['3 Dollar Bill', '191'],
    ['MEAT!', '193'],
    ['Jesus Juice', '197'],
    ['Iron Bar', '201'],
    ['Midas\' Touch', '202'],
    ['Guillotine', '206'],
    ['Ball of Bandages', '207'],
    ['Butt Bombs', '209'],
    ['Guppy\'s Collar', '212'],
    ['Lost Contact', '213'],
    ['Placenta', '218'],
    ['Old Bandage', '219'],
    ['Sad Bombs', '220'],
    ['Anti-Gravity', '222'],
    ['Gimpy', '225'],
    ['Black Lotus', '226'],
    ['Mom\'s Perfume', '228'],
    ['Monstro\'s Lung', '229'],
    ['Ball of Tar', '231'],
    ['Infamy', '242'],
    ['Blue Map', '246'],
    ['BFFS!', '247'],
    ['Hive Mind', '248'],
    ['Starter Deck', '251'],
    ['Magic Scab', '253'],
    ['Blood Clot', '254'],
    ['Fire Mind', '257'],
    ['Smart Fly', '264'],
    ['Juicy Sack', '266'],
    ['Mystery Sack', '271'],
    ['Big Fan', '279'],
    ['Aries', '300'],
    ['Virgo', '303'],
    ['Pisces', '309'],
    ['Eve\'s Mascara', '310'],
    ['Maggy\'s Bow', '312'],
    ['???\'s Only Friend', '320'],
    ['Mongo Baby', '322'],
    ['The Polaroid', '327'],
    ['The Negative', '328'],
    ['The Ludovico Technique', '329'],
    ['Soy Milk', '330'],
    ['Lazarus\' Rags', '332'],
    ['Latch Key', '343'],
    ['Bomber Boy', '353'],
    ['Crack Jacks', '354'],
    ['Mom\'s Pearls', '355'],
    ['Fate\'s Reward', '361'],
    ['Lil Chest', '362'],
    ['Continuum', '369'],
    ['Restock', '376'],
    ['No. 2', '378'],
    ['Pupula Duplex', '379'],
    ['Pay to Play', '380'],
    ['Lil Gurdy', '384'],
    ['Serpent\'s Kiss', '393'],
    ['Explosivo', '401'],
    ['Empty Vessel', '409'],
    ['Evil Eye', '410'],
    ['Cambion Conception', '412'],
    ['Deep Pockets', '416'],
    ['Fruit Cake', '418'],
    ['Circle of Protection', '423'],
    ['Night Light', '425'],
    ['PJs', '428'],
    ['Head of the Keeper', '429'],
    ['Multidimensional Baby', '431'],
    ['Glitter Bombs', '432'],
    ['Kidney Stone', '440'],
    ['Eye of Greed', '450'],
    ['Tarot Cloth', '451'],
    ['Varicose Veins', '452'],
    ['Polydactyly', '454'],
    ['Dad\'s Lost Coin', '455'],
    ['Cone Head', '457'],
    ['Sulfuric Acid', '463'],
    ['Analog Stick', '465'],
    ['Contagion', '466'],
    ['Lil Monstro', '471'],
    ['Acid Baby', '491'],
    ['YO LISTEN!', '492'],
    ['Camo Undies', '497'],
    ['Backstabber', '506'],
    ['Mom\'s Razor', '508'],
    ['Bozo', '513'],
    ['Broken Modem', '514'],
    ['Buddy in a Box', '518'],
    ['Lil Delirium', '519'],
    ['7 Seals', '526'],
    ['Pop!', '529'],
    ['Death\'s List', '530'],
    ['Lachryphagy', '532'],
    ['Trisagion', '533'],
    ['Blanket', '535'],
    ['Marbles', '538'],
    ['Flat Stone', '540'],
    ['Slipped Rib', '542'],
    ['Pointy Rib', '544'],
    ['2Spooky', '554'],
    ['Eye Sore', '558'],
    ['120 Volt', '559'],
    ['Dream Catcher', '566'],
    ['Divine Intervention', '568'],
    ['Blood Oath', '569'],
    ['Orphan Socks', '571'],
    ['Monstrance', '574'],
    ['Dirty Mind', '576'],
    ['Rocket in a Jar', '583'],
    ['Sol', '588'],
    ['Luna', '589'],
    ['Venus', '591'],
    ['Mars', '593'],
    ['Jupiter', '594'],
    ['Saturnus', '595'],
    ['Member Card', '602'],
    ['Freezer Baby', '608'],
    ['Lost Soul', '612'],
    ['Blood Bombs', '614'],
    ['Lil Dumpy', '615'],
    ['Rotten Tomato', '618'],
    ['Red Stew', '621'],
    ['Evil Charm', '632'],
    ['Purgatory', '634'],
    ['Akeldama', '641'],
    ['4.5 Volt', '647'],
    ['False PHD', '654'],
    ['Vasculitis', '657'],
    ['Quints', '661'],
    ['Tooth and Nail', '663'],
    ['Guppy\'s Eye', '665'],
    ['Strawman', '667'],
    ['Options?', '670'],
    ['Candy Heart', '671'],
    ['Redemption', '673'],
    ['Spirit Shackles', '674'],
    ['Empty Heart', '676'],
    ['Astral Projection', '677'],
    ['Bone Spurs', '683'],
    ['Soul Locket', '686'],
    ['Inner Child', '688'],
    ['The Swarm', '693'],
    ['Echo Chamber', '700'],
    ['Vengeful Spirit', '702'],
    ['Keeper\'s Kin', '717'],
    ['TMTRAINER', '721'],
    ['IBS', '725'],
    ['Hemoptysis', '726'],
    ['Ghost Bombs', '727'],
    ['Stye', '731'],
];